__turbopack_context__.v({
  "ageRestrictLink": "index-module-scss-module__0pHzsW__ageRestrictLink",
  "content": "index-module-scss-module__0pHzsW__content",
  "error": "index-module-scss-module__0pHzsW__error",
  "row": "index-module-scss-module__0pHzsW__row",
  "rowLeft": "index-module-scss-module__0pHzsW__rowLeft",
  "rowName": "index-module-scss-module__0pHzsW__rowName",
  "rowPrice": "index-module-scss-module__0pHzsW__rowPrice",
  "rowPricePer": "index-module-scss-module__0pHzsW__rowPricePer",
  "rows": "index-module-scss-module__0pHzsW__rows",
  "title": "index-module-scss-module__0pHzsW__title",
});
